import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fi-sr-id-card-clip-alt",
  "use": "icon-fi-sr-id-card-clip-alt-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-fi-sr-id-card-clip-alt\"><path d=\"m24,9v10c0,2.757-2.243,5-5,5H5c-2.757,0-5-2.243-5-5v-10c0-2.757,2.243-5,5-5h4v-1c0-1.654,1.346-3,3-3s3,1.346,3,3v1h4c2.757,0,5,2.243,5,5Zm-13-2h2.001V3c-.001-.552-.45-1-1.001-1s-1,.448-1,1v4Zm-1.5,5.5c0,1.379,1.121,2.5,2.5,2.5s2.5-1.121,2.5-2.5-1.121-2.5-2.5-2.5-2.5,1.121-2.5,2.5Zm7.468,7.251c-.559-2.174-2.648-3.751-4.968-3.751s-4.41,1.577-4.968,3.751c-.138.535.184,1.08.719,1.218.537.139,1.08-.186,1.217-.72.33-1.282,1.633-2.249,3.032-2.249s2.702.967,3.032,2.249c.116.451.522.751.968.751.082,0,.166-.01.25-.031.535-.138.857-.683.719-1.218Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fi-sr-id-card-clip-alt.svg
// module id = rNZb
// module chunks = 63